/**
 * The ignore-list, each entry with the reason it is here. Everything not named
 * below is reported, including non-Error rejection values.
 *
 * These are dropped in the browser, before the request is made: a report that
 * can never be acted on should not cost a round trip, a row, or one of the ten
 * report slots a page load gets.
 */
const IGNORED_MESSAGES = [
  // Cross-origin script; the browser withholds all detail by design, so there
  // is nothing here to act on even in principle.
  "Script error.",
  // Benign browser noise, and extremely high volume when it does fire.
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  // Routine whenever a fetch is cancelled by navigation or by React.
  "AbortError",
];

/** Someone else's bug, arriving in your table. */
const EXTENSION_FRAME = /(chrome|moz|safari-web)-extension:\/\//;

export function shouldReport(input: { message: string; stack?: string | null }): boolean {
  const message = input.message ?? "";
  if (IGNORED_MESSAGES.some((ignored) => message.includes(ignored))) return false;
  if (input.stack && EXTENSION_FRAME.test(input.stack)) return false;
  // An empty message with no stack carries nothing to act on. An empty message
  // WITH a stack is still worth having — the frame is the lead.
  if (message.trim() === "" && !input.stack) return false;
  return true;
}
